// Компонент для отображения всплывающих подсказок
import React from 'react';
import { createPortal } from 'react-dom';

// Tooltip отображает всплывающую подсказку с заданным текстом и позицией
const Tooltip = ({ tooltip, tooltipRef }) => {
  if (!tooltip.visible) {
    return null;
  }

  const tooltipNode = (
    <div
      ref={tooltipRef}
      style={{
        position: 'fixed',
        top: `${tooltip.y}px`,
        left: `${tooltip.x}px`,
        transform: 'translate(-50%, -100%)',
        background: '#ffffff',
        color: '#020217',
        padding: '10px 14px',
        borderRadius: '10px',
        border: '1px solid #dbe3ef',
        boxShadow: '0 10px 26px rgba(0, 92, 169, 0.10), 0 20px 48px rgba(2, 2, 23, 0.12)',
        zIndex: 10000,
        maxWidth: '320px',
        wordWrap: 'break-word',
        fontFamily: '"Inter", -apple-system, system-ui, "Segoe UI", Roboto, Arial, sans-serif',
        fontSize: '13px',
        fontWeight: 500,
        lineHeight: '1.45',
        pointerEvents: 'none',
        marginTop: '-8px',
      }}
      dangerouslySetInnerHTML={{ __html: tooltip.text }}
    />
  );

  return typeof document !== 'undefined'
    ? createPortal(tooltipNode, document.body)
    : tooltipNode;
};

export default Tooltip;
